import { initRipple } from './ripple';
import { initSelectComponent } from './select';
import { initCalendarComponent } from './calendar';
import { initSheetComponent } from './sheet';
import { initSticky } from './natural-middle-sticky';
import { initScrollTrigger } from './scroll-stagger';
import { initScrollTo } from './scroll-to';
import { initCurrentNavi } from './current-navi';

let initialized = false;

export function initComponents(): void {
    if (initialized) return;
    initialized = true;
    initRipple();
    initSelectComponent();
    initCalendarComponent();
    initSheetComponent();
    initSticky();
    initScrollTo();
    initScrollTrigger();
    initCurrentNavi();
}
